import React from "react";
import infoSquareIcon from "@public/img/info-square.svg";
import userWavesIcon from "@public/img/user-waves.svg";
import homeIcon from "@public/img/home.svg";
import NavItem from "./commom/nav-item";
import { Link } from "react-router-dom";
import HeaderButtons from "./parts/header-buttons";
import CategoriesNav from "./parts/categories-nav";
import "@/styles/header.css";

export default function Header() {
  return (
    <header className="site-header">
      <Link to="/" className="site-header__logo" tabIndex={-1}>WONMOV</Link>
      <HeaderButtons />

      <nav className="site-header__nav">
        <NavItem label="صفحه اصلی" icon={homeIcon} href="/" inHeader />
        <CategoriesNav />
        <NavItem label="بازیگران" icon={userWavesIcon} href="/actors" inHeader />
        <NavItem label="درباره ما" icon={infoSquareIcon} href="/about" inHeader />
      </nav>
    </header>
  );
}